import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2021-07-11' tag='Vendoo' title='Vendoo - Is Vendoo Worth It For You?'>
        ​
        <p>
          Online selling has become one of the most in-demand side hustle nowadays. Aside from being able to sell in the
          comforts of your home with just a device and internet connection, many sellers who have full-time jobs are now
          able to earn extra. In addition to this, online thrifting has become popular, too, making it fun and easy to
          sell the things that are just sitting in your closet. May it be a second-hand fashion article such as clothes,
          bags, shoes, and other items from different categories; there are many online selling marketplaces that are
          the best venue to help you find your potential buyers.
        </p>
        <p>
          One helpful trick in selling your items faster is increasing their visibility. That is why there are selling
          platforms like Poshmark that have share and relist features to help their sellers expose their items to more
          audiences. Most of the time, this strategy works, and many sellers are converting sales through these
          features. But many resellers have another trick up their sleeves that help them grow their reselling business
          and convert sales much faster. That is cross-listing to different marketplaces. Whether you are a startup
          seller or an experienced one, crossposting can be of great help in increasing your productivity when selling
          online. More platforms mean more potential buyers!
        </p>
        <p>
          While this is an effective way of earning more, cross-listing your items on multiple platforms is a
          time-consuming and laborious task. Not only can it be inconvenient if you have many items to list, but it can
          also be confusing when it comes to the rules and regulations of each platform, as none of them has the same
          business model. Because of this, cross-listing services are now available in the market to help save sellers
          time and crosspost their listings easier. One of these cross-posting software is Vendoo. Learn here if it's
          worth it for you!
        </p>
        ​<h3>What is Vendoo?</h3>​
        <p>
          Vendoo is a cross-posting software that allows sellers to list in multiple marketplaces such as Poshmark,
          Mercari, eBay, Depop, Etsy, Facebook Marketplace, Grailed, Tradesy, and Kidizen. It was founded in 2017 with a
          mission to empower and help resellers save time, grow and learn more about their business. Its CEO, Thomas
          Rivas, has experienced the pain points of selling items on multiple marketplaces hence the creation of this
          service.
        </p>
        ​
        <p>
          Vendoo offers services that will make cross-listing across different marketplaces easier and faster. Their
          basic subscription entitles sellers to have features such as:
        </p>
        <ul>
          <li>Cross-listing to three marketplaces</li>
          <li>Listing 5 items for free per month</li>
          <li>Image Hosting</li>
          <li>Inventory Page</li>
          <li>CSV Export</li>
          <li>Daily Seller Analytics (for free for a limited time)</li>
        </ul>
        ​ ​
        <p>
          They also offer add-ons which cost $4.99 each. But if you want to avail them in a bundle, you can get them all
          for $11.99.
        </p>
        ​
        <ul>
          <li>
            Importing. This will help bring your existing items from one of the marketplaces to Vendoo, so you can
            cross-post them to other platforms.
          </li>
          ​
          <li>
            Delist/Relist feature. This helps remove a listing from a marketplace and then post it as a new listing.
          </li>
          <li>
            Listing on all marketplaces. This enables a faster and easier way to list your item on all of Vendoo’s
            available marketplaces.
          </li>
        </ul>
        ​
        <p>
          Vendoo’s subscription is tiered and depends on the number of items that you list per month. Here are their
          plans:
        </p>
        <ul>
          <li>Starter Plan for $8.99/ month - 25 items</li>
          <li>Simple Plan for $19.99/ month - 125 items</li>
          <li>Plus Plan for $29.99 / month - 250 items</li>
          <li>Pro Plan for $49.99/ month - 600 items</li>
          <li>Advance Plan for $99.99/ month - 2000 items</li>
          <li>Expert Plan for $149.99/month - 4000 items</li>
        </ul>
        ​<h3>Why use Vendoo?</h3>​<p>Here are some things that can make you consider using Vendoo:</p>​
        <h4> It helps you save time</h4>
        <p>
          One of the most time-consuming and tiring things to do when selling on multiple platforms is listing manually.
          Services like Vendoo can undeniably make selling easier.
        </p>
        ​ ​ ​<h4>It can help increase listing exposure and sales</h4>
        <p>
          Increasing your items’ exposure through cross-listing in multiple marketplaces is a proven strategy in
          increasing your sales. This software is one of many in the market that can help you cross-post faster to
          expose your listing to a bigger number of audiences and eventually have increased conversions.
        </p>
        ​ ​<h4>It provides analytics</h4>
        <p>
          Their free (for now) analytics will enable you to see the sales breakdown by month or by year, revenue and
          profit by the individual marketplace, top-selling categories, and brands.{' '}
        </p>
        ​<h4>They host events with giveaways</h4>
        <p>
          From time to time, Vendoo hosts events and activities which entitle its sellers to win prizes such as vouchers
          and sometimes, free one-month subscription.
        </p>
        ​<h4>They provide Youtube tutorials</h4>
        <p>Vendoo has made video tutorials so sellers can easily follow how to use their software. </p>​
        <h4>You can cross post on nine marketplaces</h4>
        <p>
          At the moment, Vendoo can cross-list on platforms such as Poshmark, Mercari, eBay, Depop, Etsy, Facebook
          Marketplace, Grailed, Tradesy, and Kidizen. If you’re the type of seller who sells in these marketplaces,
          Vendoo may work for you.
        </p>
        ​ ​ ​ ​<h3>Cons of Vendoo</h3>​<h4>Instagram is not included</h4>
        <p>
          While they cater to many selling platforms, Instagram is not one of them. So, if you are the kind of seller
          who crossposts to marketplaces, including Instagram, Vendoo might not work for you.
        </p>
        ​<h4>Only for web browsers</h4>
        <p>
          Vendoo does not have an app that you can install and access easily with your phone or tablet. Although you can
          access it on any device with web browsers, the convenience of having an app is still favorable.{' '}
        </p>
        ​<h4>Importing is an add-on</h4>
        <p>
          If you want to import your listings from a marketplace, you will have to pay $4.99 to be able to use this
          feature. Because this is an add-on, spending extra is unavoidable if you just started using Vendoo and do not
          want to manually input all your existing listings again.{' '}
        </p>
        ​ ​<h4> United States Only, No Canadian Support</h4>
        <p>
          Vendoo said that their software is meant for USA-based sellers and platforms only and cannot be used outside.
          If you’re in Canada, you won’t be able to use this service.
        </p>
        ​<h4>Analytics need to be entered manually</h4>
        <p>
          While their analytics feature is helpful, you will still have to manually enter the information for each sale
          to be able to see the insights about your reselling business.
        </p>
        ​ ​ ​<h3>Alternatives</h3>​<h4>List Perfectly</h4>
        <p>
          List Perfectly is a paid cross-listing service that started in 2019. It is created to solve the time-consuming
          and laborious process of listing on multiple marketplaces. So far, they have the most marketplaces where you
          can cross-post, including Poshmark, Tradesy, Shopify, eBay, Etsy, Grailed, Instagram, Depop, Facebook
          Marketplace, Kidizen, and Mercari.{' '}
        </p>
        ​
        <p>
          {' '}
          List Perfectly currently offers three tiers which means the higher the fees, the more features you can use.
          They offer features like crossposting to multiple platforms with templates for faster listing, bulk
          crossposting, inventory management, access analytics and allows its subscribers to download CSVs.{' '}
        </p>
        ​
        <p>
          However, this service is only accessible on web browsers, making it inconvenient if you are on the go and want
          to quickly check your listings on your device. Also, List Perfectly is not available in Canada and only caters
          to US-based sellers.
        </p>
        ​ ​<h4>OneShop</h4>
        <p>
          The newest cross-posting software in the market is OneShop. It started as a successful Poshmark bot
          (previously SuperPosher) with thousands of satisfied subscribers. OneShop has now ventured into cross-listing
          with the software that can provide online sellers the advantage of selling in multiple marketplaces faster and
          easier to help you increase your listings’ exposure and sales.
        </p>
        <p>
          Its most unique features are being able to delist all your sold items everywhere and relist your old listings
          automatically. Yes, that is correct! OneShop has made it easier for sellers to delist their items once it gets
          sold in one marketplace, and automatically relist your old items once the system has recognized that it has
          been sitting at the bottom of your listings for too long.{' '}
        </p>
        ​
        <p>
          {' '}
          Furthermore, OneShop is the first in the market to offer an app that you can install on your iOS and Android
          device. This will make accessing and managing your listings faster and easier whether you’re on the go or just
          want to quickly check how your sales are doing.
        </p>
        ​ ​ ​<h3>Why choose OneShop?</h3>
        <p>
          {' '}
          OneShop is a crossposting app that makes it easier for you to access and manage your listings even when you're
          on the go, and it is intelligently built so you can cross-list items to multiple platforms in a fraction of
          the time. Although it's the newest software in the market for cross-listing items across online marketplaces,
          OneShop is your all-in-one platform. What's more is, with each subscription, you will get access to all
          features offered by this software. These are:{' '}
        </p>
        ​ ​<h4>Crosslist everywhere</h4>
        <p>
          OneShop can help you save time and effort in cross-listing on multiple platforms we have available. We are
          working endlessly to add more marketplaces so all our subscribers can effortlessly manage all their listings
          in one go.{' '}
        </p>
        ​ ​ ​<h4>Switch over effortlessly</h4>
        <p>
          We understand how tiring and time-consuming it is to manually list all your existing listings again. This is
          why we have made importing your data from Vendoo, ListPerfectly, or other marketplaces easier with the help of
          our team - and this is for free!
        </p>
        ​ ​ ​<h4>Sales automation</h4>
        <p>
          We made it possible to automate workflows for marketplaces like Poshmark, Mercari, and more upcoming
          marketplaces so you can reach more buyers.
        </p>
        ​ ​<h4>Sales analytics</h4>
        <p>
          We provide sales analytics so you can see how your revenue has grown and how your sales are doing compared to
          other sellers.{' '}
        </p>
        ​ ​<h4>Delist automatically</h4>
        <p>
          One of the most helpful features that OneShop has is its ability to delist your listing everywhere once it
          gets sold on one platform. And that is done automatically by its system! You don't need to worry anymore about
          having problems like double selling, being at risk of getting a negative review for canceling an order due to
          being sold on another marketplace or having your account flagged. Delisting your sold items is now made easy
          even when you have many listings across multiple platforms.{' '}
        </p>
        ​<h4>Relist automatically</h4>
        <p>
          Worrying about too many old items sitting at the bottom of your listings but don't have the time to manually
          relist them? OneShop has a solution for that! With its unique built software, OneShop can identify your
          listings that are too old on each marketplace, and it will relist items for you - automatically!
        </p>
        ​<h4>iOS and Android</h4>
        <p>
          Whether you're on the go or simply don't have time to go on our computer and check your listings, OneShop can
          be easily accessed on your tablet or mobile phone. We are the first in the market to have an app where you can
          manage all your listings, be it in one marketplace or on multiple platforms.{' '}
        </p>
        ​<h4>Background removal</h4>
        <p>
          We have a partnership with PhotoRoom, so our subscribers can get access to background removal for images and
          help you edit your item photos easily.
        </p>
        ​
        <p>
          If you want to experience intelligent software that can help you with cross-listing and make your online
          selling easier, then OneShop is for you. We want to provide sellers more time in their hands without having to
          think about babysitting multiple marketplaces. With OneShop, you won't have to spend long hours in front of
          your computer and worry about the tedious processes of crossposting, delisting, relisting, and generally
          managing your listings in different platforms as we are here to help you and make online selling a lovely
          experience for you. Now, you don't have to do all the work manually. If you are up for experiencing an
          intelligent and well-integrated system, sign-up with OneShop!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
